import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiDirectory } from '@core/api/api-directory';
import { RequestResponse } from '@core/services/request/model/request.model';
import { RequestService } from '@core/services/request/request.service';
import { LoadingIds } from '@shared/constants/loading';
import { BillingReportRequestApi } from '@core/api/model/my-invoices/billing-report-request-api.model';

@Injectable({ providedIn: 'root' })
export class ApiBillingReportRequestService {
  constructor(private _requestService: RequestService) {}

  public fetchBillingReportRequest(): Observable<RequestResponse<Array<BillingReportRequestApi>>> {
    return this._requestService.get(ApiDirectory.Facturas.ListadoInformeFacturacion({}), {
      loading: LoadingIds.FETCH_BILLING_REPORT_REQUESTS,
      hideErrorAlert: true,
    });
  }

  public downloadBillingReportRequestDocument(idPeticion: number) {
    return this._requestService.downloadWithProgress(
      ApiDirectory.Facturas.DescargaFicheroFacturacion({
        idPeticion,
      })
    );
  }
}
